export default "__VITE_ASSET__3a815ff5__"